import { EntitySearchFilterBar } from 'src/components/EntitySearch';
import { FilterDropdownItem } from 'src/components/Filters';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature, SaleQueryV2, SaleSearchResult } from 'src/WebApiController';

import { useSaleSearchFilters } from './SaleSearchFilterBar.hooks';

export const SaleSearchFilterBar = (props: {
  activeSearchConfig?: SaleSearchResult;
  onSubmitFilter?: (query: SaleQueryV2) => void;
  selectedFilters?: FilterDropdownItem[];
  setSelectedFilters: (sf: FilterDropdownItem[]) => void;
}) => {
  const hasSearchViewPerformerFilterFeature = useUserHasFeature(
    Feature.SearchViewPerformerFilter
  );

  const { filters } = useSaleSearchFilters({
    supportMultiOperation: true,
    showCatalogFilters: true,
    showVenueFilter: true,
    showPerformerFilter: hasSearchViewPerformerFilterFeature,
    isHorizontalLayout: true,
    firstRenderOpen: props.activeSearchConfig == null,
  });

  return (
    <EntitySearchFilterBar
      {...props}
      filters={filters}
      mandatoryFiltersToShow={['eventDates', 'eventOrMappingIds']}
    />
  );
};
